export default __webpack_public_path__ + "static/char-s-08-kr-20700890a0e26a539358840d14a56ad8.webp";